import { makeService } from './api';

const service = makeService('text_templates', null);

export default service;